<template>
  <v-app>
    <v-main v-show="!isLoading" :class="background">
      <v-locale-provider :rtl="isRtl" :locale="locale">
        <media-gallery v-if="isAuth && isMediaGalleryOpen" />
        <router-view />
      </v-locale-provider>
      <!-- <ZoomAlert /> -->
      <UpdatePrompt />
    </v-main>
    <loading-page v-if="isLoading" />
  </v-app>
</template>

<script lang="ts" setup>
import UpdatePrompt from '@/components/snackbars/UpdatePrompt.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import useLoadScripts, { loadMetaPixel } from '@/composables/useLoadScripts.js'
import { useLocale } from 'vuetify'
import { useAppStore } from '@/store/app'
import { useMediaStore } from '@/store/media'
import { useAuthStore } from '@/store/auth'
import { useUsersStore } from './store/user'

const { type: mediaType, isMediaGalleryOpen } = storeToRefs(useMediaStore())

const { current, isRtl: isRtlLang } = useLocale()
const route = useRoute()
const router = useRouter()
const { locale, te } = useI18n()
const { setTitle } = useAppStore()
const { isLoading, background } = storeToRefs(useAppStore())

const authStore = useAuthStore()
const { isAuth, userDetails } = storeToRefs(authStore)
const { updateUserRemote } = useUsersStore()

const isRtl = computed(() => isRtlLang.value)

onMounted(() => {
  setRouterTitle()
  useLoadScripts()
  loadMetaPixel({ eventType: 'PageView' })
})

const setRouterTitle = (name = route.name): void => {
  const routeName = `Route ${String(name)}`
  if (te(routeName)) {
    setTitle(routeName)
  }
}
watch(
  () => route.name,
  (newName: string) => {
    setRouterTitle(newName)
  }
)

const updateUserLanguage = () => {
  // Ensure userDetails exists before accessing its properties
  if (isAuth.value && userDetails.value?.lang !== locale.value) {
    updateUserRemote({
      ...userDetails.value,
      lang: locale.value,
    })
  }
}

watch(locale, () => {
  current.value = locale.value
  setRouterTitle()
  updateUserLanguage()
  router.replace({
    name: route.name,
    params: { ...route.params, lang: locale.value },
  })
})

// add query gallery to route
watch(
  isMediaGalleryOpen,
  (v: boolean) => {
    if (v && route.query.gallery === mediaType.value) return
    const query = { gallery: mediaType.value, ...route.query }
    if (!v) {
      delete query.gallery
      delete query.ansIndex
    }
    const targetRoute = { query }
    if (route.fullPath !== router.resolve(targetRoute).href) {
      router.replace(targetRoute)
    }
  },
  { immediate: false }
)
</script>
<style lang="scss">
.gameEditor {
  background-image: url('src/assets/backgrounds/gameEditor.svg');
  background-color: #ebf6ff;
}
</style>
